// import React,{Component} from "react";
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Col,
//   Alert,
//   Badge
// } from "reactstrap";
// import { Grid } from '@mui/material';
// import API from "api.js";
// import { Navigate } from "react-router-dom";
// import {userContext} from 'userContext';
// import { Helmet } from "react-helmet";
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// // import ArrowImg from 'assets/images/images_new/practice-arrow.svg';
// import AiImage from 'assets/images/images_new/ai.png';
// import SpeakingZone from 'assets/images/images_new/microphone-icon.svg';
// import WritingZone from 'assets/images/images_new/writing-icon.svg';
// import ReadingZone from 'assets/images/images_new/reading-icon.svg';
// import ListeningZone from 'assets/images/images_new/listening-icon.svg';
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import SubcategoryTitle from "Datasets/SubcategoryTitle.json";

// class Prediction extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       redirect:false,
//       type:0,
//       categoryData: []
//     };
//   }
  
//   componentDidMount() {
//     this.setSubcategories();

//     API({
//       method: 'GET',
//       url: 'prediction/count'
//     }).then(data => {
     
//       this.setState({'data':data.data.data});
//     }).catch(()=>{
      
//     });
//   }

//   showQuestion(type) {
//     this.setState({'redirect':true,'type':type});
//   }

//   showCurrentMonth = () => {
//     const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

//     const d = new Date();
//     const month = months[d.getMonth()];

//     return ` - ${month}`;
//   }

//   setSubcategories = () => {
//     const data = [
//       {
//         "zone": "Speaking",
//         "subcategories": [
//           {
//             "id": 1,
//             "name": SubcategoryTitle[1],
//             "ai": true
//           },
//           {
//             "id": 2,
//             "name": SubcategoryTitle[2],
//             "ai": true
//           },
//           {
//             "id": 3,
//             "name": SubcategoryTitle[3],
//             "ai": true
//           },
//           {
//             "id": 4,
//             "name": SubcategoryTitle[4],
//             "ai": true
//           },
//           {
//             "id": 5,
//             "name": SubcategoryTitle[5],
//             "ai": true
//           },
//           {
//             "id": 22,
//             "name": SubcategoryTitle[22],
//             "ai": true
//           },
//           {
//             "id": 21,
//             "name": SubcategoryTitle[21],
//             "ai": true
//           }
//         ]
//       },
//       {
//         "zone": "Writing",
//         "subcategories": [
//           {
//             "id": 6,
//             "name": SubcategoryTitle[6],
//             "ai": true
//           },
//           {
//             "id": 7,
//             "name": SubcategoryTitle[7],
//             "ai": true
//           }
//         ]
//       },
//       {
//         "zone": "Reading",
//         "subcategories": [
//           {
//             "id": 12,
//             "name": SubcategoryTitle[12],
//             "ai": false
//           },
//           {
//             "id": 9,
//             "name": SubcategoryTitle[9],
//             "ai": false
//           },
//           {
//             "id": 10,
//             "name": SubcategoryTitle[10],
//             "ai": false
//           },
//           {
//             "id": 11,
//             "name": SubcategoryTitle[11],
//             "ai": false
//           },
//           {
//             "id": 8,
//             "name": SubcategoryTitle[8],
//             "ai": false
//           }
//         ]
//       },
//       {
//         "zone": "Listening",
//         "subcategories": [
//           {
//             "id": 13,
//             "name": SubcategoryTitle[13],
//             "ai": true
//           },
//           {
//             "id": 14,
//             "name": SubcategoryTitle[14],
//             "ai": false
//           },
//           {
//             "id": 15,
//             "name": SubcategoryTitle[15],
//             "ai": false
//           },
//           {
//             "id": 16,
//             "name": SubcategoryTitle[16],
//             "ai": false
//           },
//           {
//             "id": 17,
//             "name": SubcategoryTitle[17],
//             "ai": false
//           },
//           {
//             "id": 18,
//             "name": SubcategoryTitle[18],
//             "ai": false
//           },
//           {
//             "id": 19,
//             "name": SubcategoryTitle[19],
//             "ai": false
//           },
//           {
//             "id": 20,
//             "name": SubcategoryTitle[20],
//             "ai": false
//           },
//            {
//             "id": 22,
//             "name": SubcategoryTitle[22],
//             "ai": false
//           },
//            {
//             "id": 21,
//             "name": SubcategoryTitle[21],
//             "ai": false
//           }
//         ]
//       }
//     ];

//     this.setState({
//       categoryData: data
//     });
//   }

//   renderSection = (section) => {
//     const { categoryData, data } = this.state;
//     let selected = null;

//     switch (section) {
//       case "Speaking":
//         selected = categoryData[0];
//         break;
//       case "Writing":
//         selected = categoryData[1];
//         break;
//       case "Reading":
//         selected = categoryData[2];
//         break;
//       case "Listening":
//         selected = categoryData[3];
//         break;
//     }

//     let html = "";
//     if (selected) {
//       html = selected.subcategories.map((item, i) => {
//         return (
//           <div className="pm-card-outer cursor-pointer" onClick={this.showQuestion.bind(this, item.id)} key={i}>
//             <div className="pm-card">
//               <div className="pm-card-content">
//                 <h2 className="pm-card-title">{item.name}</h2>
//                 {item.ai &&
//                   <img className="pm-card-img" src={AiImage} alt={item.name} />
//                 }
//               </div>
//               <div className="pm-card-bottom">
//                 <div className="pm-card-btn">VIEW</div>
//                 <Badge pill variant="light">{(item.id in data) ? data[item.id] : 0}</Badge>
//               </div>
//             </div>
//           </div>
//         )
//       })
//     }

//     return html;
//   }

//   render() {
//     if (this.state.redirect) {
//       return <Navigate to={`/admin/questions-weekly/1/${this.state.type}`} replace />;
//     }
//     return (
//       <>
//         <Helmet>
//           <title>Top PTE Training Institute</title>
//         </Helmet>
//         <div className="siteContent multipleCards monthly-predition">
//           <DashboardHeader title="Monthly Prediction Question(s)" sutitle={this.showCurrentMonth()} />
//           <Row>
//             <div className="practice-material-categories dashboard-content-wrapper pm-categories !m-0">            
//               <div className="pm-wrapper-outer speaking">
//                 <div className="pm-wrapper">
//                   <h2 className="pm-title">Speaking Zone</h2>
//                   <div className="pm-row">
//                     {this.renderSection("Speaking")}
//                   </div>
//                 </div>
//               </div>

//               <div className="pm-wrapper-outer writing">
//                 <div className="pm-wrapper">
//                   <h2 className="pm-title">Writing Zone</h2>
//                   <div className="pm-row">
//                     {this.renderSection("Writing")}
//                   </div>
//                 </div>
//               </div>

//               <div className="pm-wrapper-outer reading">
//                 <div className="pm-wrapper">
//                   <h2 className="pm-title">Reading Zone</h2>
//                   <div className="pm-row">
//                     {this.renderSection("Reading")}
//                   </div>
//                 </div>
//               </div>

//               <div className="pm-wrapper-outer listening">
//                 <div className="pm-wrapper">
//                   <h2 className="pm-title">Listening Zone</h2>
//                   <div className="pm-row">
//                     {this.renderSection("Listening")}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Row>
//         </div>
//       </>
//     );
//   }
// }
// export default Prediction;

import React, { useState, useEffect } from "react";
// import {
//   // Card,
//   // CardBody,
//   // CardHeader,
//   // CardTitle,
//   Row,
//   // Col,
//   // Alert,
//   Badge
// } from "reactstrap";
import {Row , Badge} from "react-bootstrap";
// import { Grid } from '@mui/material';
import API from "api.js";
import { Navigate } from "react-router-dom";
// import {userContext} from 'userContext';
import { Helmet } from "react-helmet";
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import ArrowImg from 'assets/images/images_new/practice-arrow.svg';
// import AiImage from 'assets/images/images_new/ai.png';
import AiImage from "../assets/images/images_new/new-ai.svg"
// import SpeakingZone from 'assets/images/images_new/microphone-icon.svg';
// import WritingZone from 'assets/images/images_new/writing-icon.svg';
// import ReadingZone from 'assets/images/images_new/reading-icon.svg';
// import ListeningZone from 'assets/images/images_new/listening-icon.svg';
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import SubcategoryTitle from "Datasets/SubcategoryTitle.json";

const Prediction = () => {
  const [data, setData] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [type, setType] = useState(0);
  const [categoryData, setCategoryData] = useState([]);

  const setSubcategories = () => {
    const subcategoryData = [
      {
        "zone": "Speaking",
        "subcategories": [
          {
            "id": 1,
            "name": SubcategoryTitle[1],
            "ai": true
          },
          {
            "id": 2,
            "name": SubcategoryTitle[2],
            "ai": true
          },
          {
            "id": 3,
            "name": SubcategoryTitle[3],
            "ai": true
          },
          {
            "id": 4,
            "name": SubcategoryTitle[4],
            "ai": true
          },
          {
            "id": 5,
            "name": SubcategoryTitle[5],
            "ai": true
          },
          {
            "id": 22,
            "name": SubcategoryTitle[22],
            "ai": true
          },
          {
            "id": 21,
            "name": SubcategoryTitle[21],
            "ai": true
          }
        ]
      },
      {
        "zone": "Writing",
        "subcategories": [
          {
            "id": 6,
            "name": SubcategoryTitle[6],
            "ai": true
          },
          {
            "id": 7,
            "name": SubcategoryTitle[7],
            "ai": true
          }
        ]
      },
      {
        "zone": "Reading",
        "subcategories": [
          
          {
            "id": 8,
            "name": SubcategoryTitle[8],
            "ai": false
          },
          {
            "id": 9,
            "name": SubcategoryTitle[9],
            "ai": false
          },
          {
            "id": 10,
            "name": SubcategoryTitle[10],
            "ai": false
          },
          {
            "id": 11,
            "name": SubcategoryTitle[11],
            "ai": false
          },
          {
            "id": 12,
            "name": SubcategoryTitle[12],
            "ai": false
          },
          
        ]
      },
      {
        "zone": "Listening",
        "subcategories": [
          {
                     "id": 13,
                     "name": SubcategoryTitle[13],
                     "ai": true
                   },
                    {
                     "id": 15,
                     "name": SubcategoryTitle[15],
                     "ai": false,
                   },
                   {
                     "id": 16,
                     "name": SubcategoryTitle[16],
                     "ai": false,
                   },    
                   {
                     "id": 17,
                     "name": SubcategoryTitle[17],
                     "ai": false,
                   },
                   {
                     "id": 14,
                     "name": SubcategoryTitle[14],
                     "ai": false,
                   },
                   {
                     "id": 18,
                     "name": SubcategoryTitle[18],
                     "ai": false,
                   },
                   {
                     "id": 19,
                     "name": SubcategoryTitle[19],
                     "ai": false,
                   },
                   {
                     "id": 20,
                     "name": SubcategoryTitle[20],
                     "ai": false,
                   },
        ]
      }
    ];

    setCategoryData(subcategoryData);
  };

  useEffect(() => {
    setSubcategories();

    API({
      method: 'GET',
      url: 'prediction/count'
    }).then((response) => {
      setData(response.data.data);
    }).catch(() => {

    });
  }, []);

  const showQuestion = (selectedType) => {
    setRedirect(true);
    setType(selectedType);
  };

  const showCurrentMonth = () => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const d = new Date();
    const month = months[d.getMonth()];

    return ` : ${month}`;
  };

  const showCurrentYear = () => {
  const d = new Date();
  return ` - ${d.getFullYear()}`;
};

  const renderSection = (section) => {
    let selected = null;

    switch (section) {
      case "Speaking":
        selected = categoryData[0];
        break;
      case "Writing":
        selected = categoryData[1];
        break;
      case "Reading":
        selected = categoryData[2];
        break;
      case "Listening":
        selected = categoryData[3];
        break;
    }

    let html = "";
    if (selected) {
      html = selected.subcategories.map((item, i) => {
        return (
          <div className="pm-card-outer cursor-pointer" onClick={() => showQuestion(item.id)} key={i}>
            <div className="pm-card">
              <div className="pm-card-content">
                <h2 className="pm-card-title">{item.name}</h2>
                {item.ai &&
                  <img className="pm-card-img" src={AiImage} alt={item.name} />
                }
              </div>
              <div className="pm-card-bottom">
                <div className="pm-card-btn">VIEW</div>
                {/* <Badge pill bg="light">{(item.id in data) ? data[item.id] : 0}</Badge> */}
                <span style={{ textDecoration: 'none' }}>
  <Badge variant="light" className="rounded-pill">
    {(item.id in data) ? data[item.id] : 0}
  </Badge>
</span>

              </div>
            </div>
          </div>
        )
      })
    }

    return html;
  };

  if (redirect) {
    return <Navigate to={`/admin/questions-weekly/1/${type}`} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>
      <div className="siteContent multipleCards monthly-predition">
        <DashboardHeader title="Monthly Prediction Question(s)" sutitle={`${showCurrentMonth()} ${showCurrentYear()}`} />
        <Row>
          <div className="practice-material-categories dashboard-content-wrapper pm-categories !m-0">
            <div className="pm-wrapper-outer speaking">
              <div className="pm-wrapper">
                <h2 className="pm-title">Speaking Zone</h2>
                <div className="pm-row">
                  {renderSection("Speaking")}
                </div>
              </div>
            </div>

            <div className="pm-wrapper-outer writing">
              <div className="pm-wrapper">
                <h2 className="pm-title">Writing Zone</h2>
                <div className="pm-row">
                  {renderSection("Writing")}
                </div>
              </div>
            </div>

            <div className="pm-wrapper-outer reading">
              <div className="pm-wrapper">
                <h2 className="pm-title">Reading Zone</h2>
                <div className="pm-row">
                  {renderSection("Reading")}
                </div>
              </div>
            </div>

            <div className="pm-wrapper-outer listening">
              <div className="pm-wrapper">
                <h2 className="pm-title">Listening Zone</h2>
                <div className="pm-row">
                  {renderSection("Listening")}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </>
  );
};

export default Prediction;
